/* The Delegations section under the Pending Approvals queue (piece 8; decision 11560): a heading row with + Add Cover, then the cover in a list. The heading is Pending Approvals' own and the hint, emphasis and add window body are the settings pages' (T3696). */
.section {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
}
